import {VideosCardLayout} from "@/components/layouts/card/VideosCardLayout";
import {RootDesc} from "@/components/ui/descriptions/RootDesc";

import {useEffect, useState} from "react";

import {
  clearOptions,
  getProductLine,
} from "@redux/slices/productSlices/optionsSlice";
import {BorderArticle} from "@ui/general/BorderArticle";
import {RootCheckbox} from "@ui/inputs/RootCheckbox";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const LibraryLayout = ({videos}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const {productLine} = useSelector((state) => state.product.options);
  const {role} = useSelector((state) => state.common.candidate);
  const [checkedLines, setCheckedLines] = useState({});

  useEffect(() => {
    if (role !== "Representative") {
      dispatch(getProductLine());
    }
    return () => {
      dispatch(clearOptions());
    };
  }, [dispatch, role]);

  const handleShowAllChange = () => {
    const newCheckedState = !Object.values(checkedLines).some(Boolean);
    const updatedCheckedLines = productLine.reduce((acc, line) => {
      acc[line.id] = newCheckedState;
      return acc;
    }, {});

    setCheckedLines(updatedCheckedLines);
  };

  const handleShow = (line) => {
    setCheckedLines((prev) => ({
      ...prev,
      [line.id]: !prev[line.id],
    }));
  };

  useEffect(() => {
    if (role !== "Representative") {
      dispatch(getProductLine());
    }

    return () => {
      dispatch(clearOptions());
    };
  }, []);

  // Инициализация всех чекбоксов как отмеченных
  useEffect(() => {
    if (productLine && productLine.length > 0) {
      const initialCheckedState = productLine.reduce((acc, line) => {
        acc[line.id] = true;
        return acc;
      }, {});
      setCheckedLines(initialCheckedState);
    }
  }, [productLine]);

  return (
    <div className={"container-big phone:p-0"}>
      <div className={styles.videosWrapper}>
        <BorderArticle>
          <div className={styles.videos}>
            <div className={styles.videosHead}>
              <H3>{t("page.simulations.library.head_title")}</H3>

              <ul>
                <li>
                  <RootCheckbox
                    onChange={handleShowAllChange}
                    label={t("page.simulations.library.checkbox_all")}
                    checked={Object.values(checkedLines).every(Boolean)}
                  />
                </li>

                {productLine &&
                  productLine.length > 0 &&
                  productLine.map((line) => (
                    <li key={line?.id}>
                      <RootCheckbox
                        onChange={() => handleShow(line)}
                        label={line?.name}
                        checked={checkedLines[line.id] || false}
                      />
                    </li>
                  ))}
              </ul>
            </div>

            {!videos ||
              (videos.length === 0 && (
                <RootDesc>
                  <span>{t("page.simulations.library.no_videos")}</span>
                </RootDesc>
              ))}

            <ul className={styles.videosList}>
              {videos &&
                videos.map((item) => (
                  <li key={item?.id}>
                    <VideosCardLayout video={item} />
                  </li>
                ))}
            </ul>
          </div>
        </BorderArticle>
      </div>
    </div>
  );
};
